import { AxiosClient } from '@/app/common/services/http/axios-client.service'
import store from '@/plugins/store'
import { GetAllLifeInsurancesCommand } from '@/app/life-insurance/commands/get-all-life-insurances.command'

const httpClient = new AxiosClient()

export const getAllLifeInsurancesCommand = new GetAllLifeInsurancesCommand(httpClient, store)
